import { Injectable } from '@angular/core'
import { Subject } from 'rxjs/Subject'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { AuthService } from './auth.services'
import { User } from '@models/user'

@Injectable()
export class SharedServices {
    groupMenuList = ''
    clinicRouterArr = [
        {
            id: 1,
            routerLink: 'aligner',
            name: 'app-status-aligner',
            icon: 'icon-bag',
            nameMonitor: 'Clinic',
            routerDefault: '/app/main/status/aligner',
        },
        { id: 2, routerLink: 'mail', name: 'app-status-mail-history' },
        { id: 3, routerLink: 'broadcastmail', name: 'app-status-broadcast-mail-history' },
        { id: 4, routerLink: 'chat', name: 'app-status-chat-history' },
        { id: 5, routerLink: 'audit', name: 'app-status-audit' },
    ]

    settingRouterArr = [
        {
            id: 1,
            routerLink: 'staff',
            name: 'app-setting-staff',
            icon: 'icon-settings',
            nameMonitor: 'Setting',
            routerDefault: '/app/main/setting/staff',
        },
        { id: 2, routerLink: 'clinic', name: 'app-setting-clinic' },
        { id: 3, routerLink: 'common', name: 'app-setting-common-settings' },
        { id: 4, routerLink: 'option', name: 'app-setting-option-settings' },
        { id: 5, routerLink: 'mail', name: 'app-setting-mail' },
        { id: 6, routerLink: 'device', name: 'app-setting-device' },
        { id: 7, routerLink: 'payment', name: 'app-setting-payment' },
        { id: 8, routerLink: '', link: 'https://sites.google.com/view/orthocomm-tutorial/%E8%A7%A3%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6?authuser=0', name: 'app-setting-cancellation' },
    ]

    communicationRouterArr = [
        {
            id: 1,
            routerLink: 'top',
            name: 'app-top-commuication',
            icon: 'icon-bubbles',
            nameMonitor: 'Communication',
            routerDefault: '/app/main/communication',
        },
        { id: 2, routerLink: 'list', name: 'app-list-commuication' },
        { id: 3, routerLink: 'new', name: 'app-new-commuication' },
    ]
    communicationroomRouterArr = [
        { id: 1, routerLink: 'Timeline', name: 'app-timeline', activeDefault: true },
        { id: 2, routerLink: 'Setting', name: 'app-setting-commuication' },
    ]

    clientRouterArr = [
        {
            id: 1,
            routerLink: 'search',
            name: 'app-client-select-client',
            icon: 'icon-people',
            nameMonitor: 'Client',
            routerDefault: '/app/main/client/search',
        },
        { id: 2, routerLink: 'new', name: 'app-client-new-client' },
    ]

    presentationModeValue: any
    idClient
    arrayKeySearchValuesChangeForUser: any
    isShow: any
    view: any

    constructor(private authService: AuthService) {
    }

    // Observable string sources
    private emitChangeSource = new Subject<any>()
    private _emitShowBigImage = new Subject<any>()
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable()
    showBigImageEmitted$ = this._emitShowBigImage.asObservable()
    private emitChangeSourceParent = new Subject<any>()
    changeEmittedSource$ = this.emitChangeSourceParent.asObservable()
    changeEmittedPresentationModeSearchData$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmitChangeImageFace$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedIsShowConfirm$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedChangeLanguage$: BehaviorSubject<any> = new BehaviorSubject(null)
    language$ = this.changeEmittedChangeLanguage$.asObservable();
    // Service message commands
    emitChange(change: any) {
        this.emitChangeSource.next(change)
    }

    emitShowBigImage(change: any) {
        this._emitShowBigImage.next(change)
    }

    emitChangeLanguage(change: any) {
        this.changeEmittedChangeLanguage$.next(change)
    }

    emitChangeParent(change: any) {
        this.emitChangeSourceParent.next(change)
    }

    emitChangeIsShowConfirm(change: any) {
        if (change != null && change != undefined && change['status'] != undefined) {
            if (this.isShow != change['status'] || this.view != change['view']) {
                this.isShow = change['status']
                this.changeEmittedIsShowConfirm$.next(change)
            }
        }
    }

    emitChangeImageFace(data: any) {
        this.changeEmitChangeImageFace$.next(data)
    }

    // arr check to top
    returnArrayMenu() {
        if (this.groupMenuList == 'clinic') {
            return this.clinicRouterArr
        } else if (this.groupMenuList == 'setting') {
            return this.getSettingRouterArr()
        } else if (this.groupMenuList == 'client') {
            return this.clientRouterArr
        } else if (this.groupMenuList == 'communication') {
            return this.communicationRouterArr
        }
    }

    // check top
    checkListMenulefft(groupMenu) {
        if (groupMenu == 'clinic') {
            this.groupMenuList = 'clinic'
        } else if (groupMenu == 'setting') {
            this.groupMenuList = 'setting'
        } else if (groupMenu == 'client') {
            this.groupMenuList = 'client'
        } else if (groupMenu == 'communication') {
            this.groupMenuList = 'communication'
        }
    }

    returnArraymenuleft(nameMenuleft) {
        if (nameMenuleft == 'status') {
            return this.clinicRouterArr
        } else if (nameMenuleft == 'setting') {
            return this.getSettingRouterArr()
        } else if (nameMenuleft == 'client') {
            return this.clientRouterArr
        } else if (nameMenuleft == 'communication') {
            return this.communicationRouterArr
        } else if (nameMenuleft == 'communication_room') {
            return this.communicationroomRouterArr
        }
    }

    getIdParam(idClient) {
        this.idClient = idClient
        localStorage.setItem('idClient', idClient)
    }

    getlisIfSearch(arrayKeySearchValuesChangeForUser) {
        this.arrayKeySearchValuesChangeForUser = arrayKeySearchValuesChangeForUser
    }

    emitChangePresentationModeSearchData(data: any) {
        this.changeEmittedPresentationModeSearchData$.next(data)
    }

    getSettingRouterArr() {
        const result = this.settingRouterArr
        const statusMobile = this.authService.getUser().appMobile
        if (statusMobile === false) {
            const deviceIndex = result.findIndex(item => item.routerLink == 'device')
            if (deviceIndex >= 0)
                result.splice(deviceIndex, 1) //device
        }
        return result
    }


    getUser(): User {
        const user = this.getItem('user')
        if (user) return JSON.parse(user)
    }

    getClientId() {
        return localStorage.getItem('idClient')
    }

    private getItem(name) {
        if (localStorage.getItem(name)) {
            return this.b64DecodeUnicode(`${ JSON.parse(localStorage.getItem(name)) }`)
        } else {
            return false
        }
    }

    private b64DecodeUnicode(str) {
        return str
    }

    getCurrentLanguagePayment(): string {
        return localStorage.getItem('lang') || 'en';
    }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.services.ts